import { AthleticTrainerSerializer } from 'services/serializers/v2';
import ApiService from '../ApiService';

class AthleticTrainerService extends ApiService {
  constructor(session) {
    super(session);

    this.url = '/v2/athletic_trainers';
  }

  getAT(id) {
    return super.get(`${this.url}/${id}.json`, response => {
      return AthleticTrainerSerializer.deserialize(response);
    });
  }

  getATStatistics(id) {
    const userId = id;
    return super.get(`${this.url}/${userId}/statistics.json`, response =>
      AthleticTrainerSerializer.deserializeStatistics(userId, response)
    );
  }
}

export default AthleticTrainerService;
